import { Textarea, type TextareaProps } from "../core/Textarea/Textarea";
import { useFieldConnection, type ConnectedFieldProps } from "./useFieldConnection";

export interface TextareaFieldProps
  extends Omit<TextareaProps, "name">,
    ConnectedFieldProps {}

/**
 * El área de texto ya cableada al formulario que la envuelve. Hermano
 * exacto de `TextField`, con `Textarea` en vez de `Input`.
 *
 * Todo lo demás (`label`, `placeholder`, `hint`, `rows`, `required`…)
 * viaja tal cual, así que la accesibilidad —`htmlFor`, `aria-describedby`,
 * `aria-invalid`, los ids de error y pista— sigue siendo la que `Textarea`
 * ya resolvía. Este componente no toca ARIA: solo deja de obligar a las
 * pantallas a pasar `register`, `error` y `disabled` a mano.
 *
 * Cualquier prop explícito GANA sobre lo que viene del formulario.
 */
export function TextareaField({
  name,
  registerOptions,
  disabled,
  error,
  ...rest
}: TextareaFieldProps) {
  const field = useFieldConnection(name, registerOptions);

  return (
    <Textarea
      {...rest}
      disabled={disabled ?? field.disabled}
      error={error ?? field.error}
      {...field.registration}
    />
  );
}
